import { Component, ViewChild } from '@angular/core';
import {
  DATA_SERVICE_TOKEN,
  EoSearchPageComponent,
  SearchPageOptionsService,
} from 'ngx-eo-web-components';
import { Surgery } from '../../../core/models/surgery.model';
import {
  privateSurgerySearchFormConfig,
  initSurgerySearchForm,
  setSearchParams,
} from '../../config/surgeries-private-search-form.config';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PrivateSurgeriesTableConfigBuilder } from '../../config/surgeries-private-search.config';
import { AuthService } from '../../../../services/auth/auth.service';
import { SurgeryPrivateService } from '../../../../services/surgery/surgery.pr.service';
import { SurgeryUnableToContactFormDialogComponent } from '../../../surgery/components/surgery-unable-to-contact-form-dialog/surgery-unable-to-contact-form-dialog.component';

@Component({
  selector: 'app-surgeries-private-list',
  templateUrl: './surgeries-private-list.component.html',
  styleUrl: './surgeries-private-list.component.scss',
  providers: [
    SearchPageOptionsService,
    { provide: DATA_SERVICE_TOKEN, useClass: SurgeryPrivateService },
  ],
})
export class SurgeriesPrivateListComponent extends EoSearchPageComponent<Surgery> {
  @ViewChild('surgeryUnableToContactFormDialog', { static: false })
  surgeryUnableToContactFormDialog?: SurgeryUnableToContactFormDialogComponent;

  hospitalId?: string | null;

  data$ = new BehaviorSubject<Surgery[]>([]);
  token$ = this.authService.token$;
  tokenData = this.token$.getValue();

  override tableConfig = this.getSurgeryTableConfig();
  showUnableToContactDialog: any;

  protected getSurgeryTableConfig() {
    let data = this.searchService.searchCh.data$.getValue()?.resultset ?? [];

    return new PrivateSurgeriesTableConfigBuilder()
      .addIdikaSurgeryOperationsEllipsisFunction(
        this.idikaSurgeryOperationsFullText.bind(this)
      )
      .addCommunicationFailedSurgeryFunction(
        this.communicationFailedSurgery.bind(this)
      )
      .addIsCommunicationFailedSurgeryBtnVisibleFunction(
        this.iscommunicationFailedSurgeryBtnVisible.bind(this)
      )
      .addSurgeryStatusNameFunction(this.surgeryStatusNameCheck.bind(this))
      .getTable(data);
  }

  private surgeryStatusNameCheck(surgery?: Surgery): string {
    return surgery?.surgeryStatusAlias == 'communication-failed'
      ? this.getCanceledTooltipHtml(surgery)
      : '';
  }

  getCanceledTooltipHtml(surgery: Surgery): string {
    return `<strong>Σχόλιο</strong>: ${surgery?.cancelComments ?? '-'}`;
  }

  override defaultSearchParam = {
    hospitalID: '',
    clinicID: null as string | null,
    dateFrom: null as Date | null,
    dateTo: null as Date | null,
    patientAmka: null as string | null,
  };

  override searchParam = { ...this.defaultSearchParam };
  override formConfig = privateSurgerySearchFormConfig;

  constructor(
    override searchService: SurgeryPrivateService,
    private authService: AuthService
  ) {
    super(searchService);
  }

  private idikaSurgeryOperationsFullText(surgery?: Surgery): string {
    return this.getIdikaSurgeryOperationsFullText(surgery);
  }

  isToolTipVisible(): boolean {
    return this.authService.hasRoles(['!ClinicAdmin']);
  }

  private communicationFailedSurgery(surgery?: Surgery, $event?: any): void {
    if (surgery) {
      //console.log('communicationFailedSurgery', surgery);
      this.surgeryUnableToContactFormDialog?.show(surgery);
    }
  }

  //TODO: get surgeryStatusAlias in surgery model
  private iscommunicationFailedSurgeryBtnVisible(surgery?: Surgery): boolean {
    //console.log("Status",surgery?.surgeryStatusAlias);
    const statusAlias = surgery?.surgeryStatusAlias.toLowerCase();
    return statusAlias === 'toprivate';
    // return true;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.searchService.searchCh.data$.subscribe(() => {
      if (this.tableConfig) {
        this.tableConfig = this.getSurgeryTableConfig();
      }
    });
  }

  private initForm(clinicID: string | null, savedSearchParams?: any) {
    this.hospitalId = this.tokenData?.hospitalId || null;

    initSurgerySearchForm(
      this.hospitalId,
      clinicID,
      this.authService.hasRoles(['ClinicAdmin'])
    );

    if (this.hospitalId) {
      this.onSearch({
        form: {
          hospitalID: this.hospitalId,
          clinicID: clinicID,
          dateFrom: savedSearchParams?.dateFrom,
          dateTo: savedSearchParams?.dateTo,
          patientAmka: savedSearchParams?.patientAmka,
        },
      });
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let clinicID = this.tokenData?.clinicId || null;
      const savedSearchParams = this.searchService.getSavedSearchParams();
      if (savedSearchParams) {
        setSearchParams(savedSearchParams);
        clinicID = savedSearchParams.clinicID;
        this.initForm(clinicID, savedSearchParams);
      } else {
        this.initForm(clinicID, null);
      }
    });
  }

  onSearch(searchParams?: any) {
    const savedSearchParamsPr = this.searchService.getSavedSearchParams();

    this.searchParam =
      searchParams?.form || savedSearchParamsPr || this.defaultSearchParam;

    //console.log("searchParam::", this.searchParam);
    this.searchService
      .searchPrivateSurgeries(
        this.searchParam,
        this.getPagesize(),
        this.getPage()
      )
      .subscribe();
  }

  override getTotalCount(): number {
    return this.searchService.searchCh.data$.getValue()?.totalCount ?? 0;
  }

  onHospitalChange($event: any) {
    this.hospitalId = $event.value || null; // Set hospitalId to selected hospital ID
  }

  onClearEvent() {
    // Clear the search service
    this.searchService.searchCh.init();
    let clinicID = this.tokenData?.clinicId || null;

    initSurgerySearchForm(
      this.hospitalId,
      clinicID,
      this.authService.hasRoles(['ClinicAdmin'])
    );

    if (this.hospitalId) {
      this.onSearch({
        form: {
          hospitalID: this.hospitalId,
          clinicID: clinicID,
        },
      });
    }
  }

  onTriggerSearch() {
    this.onSearch();
  }

  getIdikaSurgeryOperationsFullText(surgery?: Surgery): string {
    return surgery?.idikaSurgeryOperations ?? '';
  }
}
